import $ from "jquery";

const mobileSidebar = () => {
    const init = () => {
        execute();
    };

    const el = {
        main: ".js-mobile-sidebar",
        mobileTogglebtn: ".js-toggle-mobile",
        langBtn: ".js-lang-btn",
        langDropdwon: ".js-lang-dropdown",
        closeBtnSidebar: ".js-mobile-sidebar-close",
    };
    if ($(el.main).length === 0) return;

    const execute = () => {
        $(document).on("click", el.mobileTogglebtn, function (e) {
            e.preventDefault();

            $(el.main).fadeToggle();
        });

        $(document).on("click", el.closeBtnSidebar, function (e) {
            e.preventDefault();

            $(el.main).fadeToggle();
        });

        $(document).on("click", el.langBtn, function (e) {
            e.preventDefault();

            $(this).toggleClass("active");
            $(el.langDropdwon).fadeToggle();
        });
    };

    init();
};

try {
    mobileSidebar();
} catch (error) {
    console.error("mobileSidebar", error);
}